import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  Table,
  Alert,
  Switch,
  Input,
  message,
  Popconfirm,
  Button,
  Collapse,
  Form,
  Tabs,
} from "antd";
import PropTypes from "prop-types";
import {
  req_edit_lrs_spaceInformation,
  req_list_lrs_spaceSessionTimeStandardLimit,
  req_add_lrs_spaceSessionTimeStandard,
  req_delete_lrs_spaceSessionTimeStandard,
  req_edit_lrs_spaceSessionTimeStandard,
} from "../../api";
import { usrRole } from "../../utils/dataUtil";

const { Panel } = Collapse;

class TimeModalConfig extends Component {
  state = {
    loading: false,
    item: null,
    items: [],
    space: {},
    editMode: false,
    selectedTab: "1",
    isCustomizeTime: "NO",
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    this.init_value();
  }

  componentDidMount() {
    this.api_list_items();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    this.setState({ items: [] });
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const { RoomCode } = this.props.space;

    this.setState({ loading: true });
    const result = await req_list_lrs_spaceSessionTimeStandardLimit(
      userLevel,
      userCode,
      RoomCode,
      token
    );
    if (result.total) {
      const { selectedTab } = this.state;
      let items = [];
      if (result.total > 0) {
        items = result.data.filter(function (el) {
          return el.WeekCode === selectedTab;
        });
        this.setState({ items });
      } else {
        this.setState({ items: [] });
      }
      this.setState({ loading: false });
    } else {
      this.setState({ loading: false });
    }
  };

  api_add_item = async (item) => {
    //console.log(item);
    const { token } = this.props.user;
    const result = await req_add_lrs_spaceSessionTimeStandard(item, token);
    if (result.status === "success") {
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };

  api_del_items = async (item) => {
    //console.log(item);
    const { token } = this.props.user;
    const { condition, RoomCode } = item;
    const result = await req_delete_lrs_spaceSessionTimeStandard(
      condition,
      RoomCode,
      token
    );
    if (result.status === "success") {
      //message.info(result.message);
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };
  
  api_del_item = async (item) => {
    //console.log(item);
    const { token } = this.props.user;
    const { condition, Uid } = item;
    const result = await req_delete_lrs_spaceSessionTimeStandard(
      condition,
      Uid,
      token
    );
    if (result.status === "success") {
      //message.info(result.message);
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    //console.log(item);
    const result = await req_edit_lrs_spaceSessionTimeStandard(item, token);
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_modify_space = async (item, customizeTime) => {
    const { token } = this.props.user;
    //console.log(item);
    const result = await req_edit_lrs_spaceInformation(item, token);
    if (result.status === "success") {
      // message.success(result.message);
      if (customizeTime === "NO") {
        //還原SESSIONTIME數據
        const sessiontime = {
          condition: "TEMPLATE",
          RoomCode: item.RoomCode,
        };
        this.handle_add_item(sessiontime);
      } else {
        //移除SESSIONTIME數據
        const sessiontime = {
          condition: "ROOMCODE",
          RoomCode: item.RoomCode,
        };
        this.api_del_items(sessiontime);
      }
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "分類",
        dataIndex: "Division",
        width: 20,
      },
      {
        title: "節次",
        width: 50,
        responsive: ["md"],
        render: (item) => {
          const { TimeName } = item;
          const { editMode } = this.state;
          return (
            <>
              <Input
                className="form-control"
                placeholder="請輸入節次名稱"
                disabled={editMode === true ? false : true}
                style={{
                  backgroundColor:
                    editMode === true ? "LightYellow" : "LightGray",
                }}
                defaultValue={TimeName}
                onChange={(e) =>
                  this.handle_input_change(
                    e.target.value,
                    "SESSIONTIMENAME",
                    item
                  )
                }
              />
            </>
          );
        },
      },
      {
        title: "起始時間",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { TimeStart } = item;
          const { editMode } = this.state;
          return (
            <>
              <Input
                className="form-control"
                placeholder="0000"
                disabled={editMode === true ? false : true}
                style={{
                  backgroundColor:
                    editMode === true ? "LightYellow" : "LightGray",
                }}
                defaultValue={TimeStart}
                onChange={(e) =>
                  this.handle_input_change(e.target.value, "STARTTIME", item)
                }
              />
            </>
          );
        },
      },
      {
        title: "結束時間",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { TimeEnd } = item;
          const { editMode } = this.state;
          return (
            <>
              <Input
                className="form-control"
                placeholder="0000"
                disabled={editMode === true ? false : true}
                style={{
                  backgroundColor:
                    editMode === true ? "LightYellow" : "LightGray",
                }}
                defaultValue={TimeEnd}
                onChange={(e) =>
                  this.handle_input_change(e.target.value, "ENDTIME", item)
                }
              />
            </>
          );
        },
      },
      {
        title: "預設狀態",
        width: 20,
        render: (item) => {
          const { editMode } = this.state;
          const { DefaultStatus } = item;
          return (
            <>
              <Switch
                checkedChildren="開放"
                unCheckedChildren="關閉"
                disabled={editMode === true ? false : true}
                defaultChecked={DefaultStatus === "OPEN" ? true : false}
                onChange={(e) => this.handle_switch_change(e, item)}
              />
            </>
          );
        },
      },
      {
        title: "操作",
        width: 30,
        render: (item) => {
          const { editMode } = this.state;
          return (
            <>
              <Popconfirm
                title="確定要刪除此時段"
                onConfirm={() => this.handle_show_ui_modal("DELETE", item)}
              >
                <Button
                  type="primary"
                  disabled={editMode === true ? false : true}
                >
                  <i className="fa fa-minus-circle"></i>
                  <span style={{ marginLeft: "4px" }}>刪除</span>
                </Button>
              </Popconfirm>
            </>
          );
        },
      },
    ];
  };

  init_value = () => {
    const { IsCustomizeTime } = this.props.space;
    const editMode = IsCustomizeTime === "YES" ? true : false;
    //console.log(IsCustomizeTime)
    this.setState({
      item: this.props.space,
      isCustomizeTime: IsCustomizeTime,
      editMode: editMode,
    });
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_form_finish = (values) => {
    const { selectedTab } = this.state;
    const { TimeName, TimeStart, TimeEnd } = values;
    const { RoomCode } = this.props.space;
    //console.log(values);
    const item = {
      RoomCode: RoomCode,
      Division: TimeStart,
      TimeName: TimeName,
      WeekCode: selectedTab,
      TimeStart: TimeStart,
      TimeEnd: TimeEnd,
      DefaultStatus: "OPEN",
      InsideCode: "0",
      CourseTableNum: "0",
    };
    this.api_add_item(item);
  };

  handle_add_item = (item) => {
    this.api_add_item(item);
  };

  handle_delete_item = (item) => {
    this.api_del_item(item);
  };

  handle_edit_item = (condition, item) => {
    item.condition = condition;
    this.api_modify_item(item);
  };

  //////////////////////////

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "ADD":
        this.setState({ isShowAddModal: true });
        break;
      // case "EDIT":
      //   this.setState({ isShowEditModal: true });
      //   break;
      case "DELETE":
        //console.log(item);
        const target = {
          Uid: item.Uid,
          condition: "GUID",
        };
        this.handle_delete_item(target);
        break;
      case "CUSTOMIZE":
        break;
      default:
    }
    this.setState({ item: item });
  };

  //////////////////////////

  handle_input_change(value, condition, item) {
    const { Uid } = item;
    const obj = {
      condition: condition,
      TimeName: value,
      TimeStart: value,
      TimeEnd: value,
      Uid: Uid,
    };
    this.handle_edit_item(condition, obj);
  }

  handle_select_change(value, item) {
    console.log(value);
    console.log(item);
    const row = {
      Uid: item.Uid,
      SpaceSiteNId: value,
      condition: "SITE",
    };
    this.api_modify_item(row);
  }

  handle_switch_change(checked, item) {
    const { Uid } = item;
    const DefaultStatus = checked === false ? "OPEN" : "CLOLSE";
    const obj = {
      condition: "STATUS",
      DefaultStatus: DefaultStatus,
      Uid: Uid,
    };
    this.handle_edit_item("STATUS", obj);
  }

  handle_tab_change = (key) => {
    //console.log(key);
    this.setState({ selectedTab: key }, () => {
      this.api_list_items();
    });
  };

  handle_customize_event = (item) => {
    const { RoomCode } = item;
    const isCustomizeTime = "YES";
    const editMode = true;
    //1.回寫SPCAE IsCustomizeTime參數
    const space = {
      condition: "CUSTOMIZETIME",
      RoomCode: RoomCode,
      IsCustomizeTime: isCustomizeTime,
    };
    this.api_modify_space(space);
    //3.開啟編輯模式
    this.setState({ isCustomizeTime, editMode });
  };

  handle_default_event = () => {
    const { RoomCode } = this.props.space;
    const isCustomizeTime = "NO";
    const editMode = false;
    //1.回寫SPCAE IsCustomizeTime參數
    const space = {
      condition: "CUSTOMIZETIME",
      RoomCode: RoomCode,
      IsCustomizeTime: isCustomizeTime,
    };
    this.api_modify_space(space, isCustomizeTime);
    //2.關閉編輯模式
    this.setState({ isCustomizeTime, editMode });
  };

  //////////////////////////////////////////////////////////

  render() {
    const { loading, item, items, editMode, isCustomizeTime } = this.state;
    const { RoomCode, RoomTwName } = this.props.space;
    //console.log(isCustomizeTime);
    return (
      <Card>
        <div>
          <Alert
            message={
              <div style={{ color: "red", fontSize: "1.3em" }}>
                ({RoomCode}){RoomTwName}{" "}
                {isCustomizeTime === "NO" ? (
                  <>
                    <Popconfirm
                      title="注意改用自訂時段，將清除所有預設時段，且所建時段將不會自動排除校內開課時間"
                      onConfirm={() => this.handle_customize_event(item)}
                    >
                      <Button type="primary">
                      <i className="fa fa-unlock"></i>
                        <span style={{ marginLeft: "4px" }}>改用自訂時段</span>
                      </Button>
                    </Popconfirm>
                  </>
                ) : (
                  <button
                    className="btn btn-success btn-sm"
                    onClick={this.handle_default_event}
                  >
                    <i className="fa fa-share"></i> 還原預設時段
                  </button>
                )}
              </div>
            }
            type="success"
          />
        </div>
        <Tabs defaultActiveKey="1" onChange={this.handle_tab_change}>
          <Tabs.TabPane tab="週一" key="1">
            <Collapse accordion>
              <Panel
                header={
                  <>
                    <i className="fa fa-plus-square"></i> 新增時段
                  </>
                }
                key="1"
              >
                <Form layout={"inline"} onFinish={this.handle_form_finish}>
                  <Form.Item
                    label="節次名稱"
                    name="TimeName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="請輸入節次名稱" />
                  </Form.Item>
                  <Form.Item
                    label="起始時間"
                    name="TimeStart"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item
                    label="結束時間"
                    name="TimeEnd"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={editMode === true ? false : true}
                    >
                      <i className="fa fa-plus-circle"></i>{" "}
                      <span style={{ marginLeft: "4px" }}>新增</span>
                    </Button>
                  </Form.Item>
                </Form>
              </Panel>
            </Collapse>
            <Table
              dataSource={items}
              columns={this.columns}
              loading={loading}
              rowKey="Uid"
              scroll={{ y: 460 }}
              width="70%"
              pagination={false}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="週二" key="2">
            <Collapse accordion>
              <Panel
                header={
                  <>
                    <i className="fa fa-plus-square"></i> 新增時段
                  </>
                }
                key="1"
              >
                <Form layout={"inline"} onFinish={this.handle_form_finish}>
                  <Form.Item
                    label="節次名稱"
                    name="TimeName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="請輸入節次名稱" />
                  </Form.Item>
                  <Form.Item
                    label="起始時間"
                    name="TimeStart"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item
                    label="結束時間"
                    name="TimeEnd"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={editMode === true ? false : true}
                    >
                      <i className="fa fa-plus-circle"></i>{" "}
                      <span style={{ marginLeft: "4px" }}>新增</span>
                    </Button>
                  </Form.Item>
                </Form>
              </Panel>
            </Collapse>
            <Table
              dataSource={items}
              columns={this.columns}
              loading={loading}
              rowKey="Uid"
              scroll={{ y: 460 }}
              width="70%"
              pagination={false}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="週三" key="3">
            <Collapse accordion>
              <Panel
                header={
                  <>
                    <i className="fa fa-plus-square"></i> 新增時段
                  </>
                }
                key="1"
              >
                <Form layout={"inline"} onFinish={this.handle_form_finish}>
                  <Form.Item
                    label="節次名稱"
                    name="TimeName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="請輸入節次名稱" />
                  </Form.Item>
                  <Form.Item
                    label="起始時間"
                    name="TimeStart"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item
                    label="結束時間"
                    name="TimeEnd"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={editMode === true ? false : true}
                    >
                      <i className="fa fa-plus-circle"></i>{" "}
                      <span style={{ marginLeft: "4px" }}>新增</span>
                    </Button>
                  </Form.Item>
                </Form>
              </Panel>
            </Collapse>
            <Table
              dataSource={items}
              columns={this.columns}
              loading={loading}
              rowKey="Uid"
              scroll={{ y: 460 }}
              width="70%"
              pagination={false}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="週四" key="4">
            <Collapse accordion>
              <Panel
                header={
                  <>
                    <i className="fa fa-plus-square"></i> 新增時段
                  </>
                }
                key="1"
              >
                <Form layout={"inline"} onFinish={this.handle_form_finish}>
                  <Form.Item
                    label="節次名稱"
                    name="TimeName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="請輸入節次名稱" />
                  </Form.Item>
                  <Form.Item
                    label="起始時間"
                    name="TimeStart"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item
                    label="結束時間"
                    name="TimeEnd"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={editMode === true ? false : true}
                    >
                      <i className="fa fa-plus-circle"></i>{" "}
                      <span style={{ marginLeft: "4px" }}>新增</span>
                    </Button>
                  </Form.Item>
                </Form>
              </Panel>
            </Collapse>
            <Table
              dataSource={items}
              columns={this.columns}
              loading={loading}
              rowKey="Uid"
              scroll={{ y: 460 }}
              width="70%"
              pagination={false}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="週五" key="5">
            <Collapse accordion>
              <Panel
                header={
                  <>
                    <i className="fa fa-plus-square"></i> 新增時段
                  </>
                }
                key="1"
              >
                <Form layout={"inline"} onFinish={this.handle_form_finish}>
                  <Form.Item
                    label="節次名稱"
                    name="TimeName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="請輸入節次名稱" />
                  </Form.Item>
                  <Form.Item
                    label="起始時間"
                    name="TimeStart"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item
                    label="結束時間"
                    name="TimeEnd"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={editMode === true ? false : true}
                    >
                      <i className="fa fa-plus-circle"></i>{" "}
                      <span style={{ marginLeft: "4px" }}>新增</span>
                    </Button>
                  </Form.Item>
                </Form>
              </Panel>
            </Collapse>
            <Table
              dataSource={items}
              columns={this.columns}
              loading={loading}
              rowKey="Uid"
              scroll={{ y: 460 }}
              width="70%"
              pagination={false}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="週六" key="6">
            <Collapse accordion>
              <Panel
                header={
                  <>
                    <i className="fa fa-plus-square"></i> 新增時段
                  </>
                }
                key="1"
              >
                <Form layout={"inline"} onFinish={this.handle_form_finish}>
                  <Form.Item
                    label="節次名稱"
                    name="TimeName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="請輸入節次名稱" />
                  </Form.Item>
                  <Form.Item
                    label="起始時間"
                    name="TimeStart"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item
                    label="結束時間"
                    name="TimeEnd"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={editMode === true ? false : true}
                    >
                      <i className="fa fa-plus-circle"></i>{" "}
                      <span style={{ marginLeft: "4px" }}>新增</span>
                    </Button>
                  </Form.Item>
                </Form>
              </Panel>
            </Collapse>
            <Table
              dataSource={items}
              columns={this.columns}
              loading={loading}
              rowKey="Uid"
              scroll={{ y: 460 }}
              width="70%"
              pagination={false}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="週日" key="7">
            <Collapse accordion>
              <Panel
                header={
                  <>
                    <i className="fa fa-plus-square"></i> 新增時段
                  </>
                }
                key="1"
              >
                <Form layout={"inline"} onFinish={this.handle_form_finish}>
                  <Form.Item
                    label="節次名稱"
                    name="TimeName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="請輸入節次名稱" />
                  </Form.Item>
                  <Form.Item
                    label="起始時間"
                    name="TimeStart"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item
                    label="結束時間"
                    name="TimeEnd"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="0000" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={editMode === true ? false : true}
                    >
                      <i className="fa fa-plus-circle"></i>{" "}
                      <span style={{ marginLeft: "4px" }}>新增</span>
                    </Button>
                  </Form.Item>
                </Form>
              </Panel>
            </Collapse>
            <Table
              dataSource={items}
              columns={this.columns}
              loading={loading}
              rowKey="Uid"
              scroll={{ y: 460 }}
              width="70%"
              pagination={false}
            />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(TimeModalConfig);
